import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import BreathingExercise from '../components/BreathingExercise';

interface TheResetPageProps {
  navigate: (view: string, slug: string) => void;
}

const TheResetPage: React.FC<TheResetPageProps> = ({ navigate }) => {
  const { t } = useLanguage();
  const [showExercise, setShowExercise] = useState(false);

  if (showExercise) {
    return (
      <div className="container mx-auto max-w-3xl">
        <button
          onClick={() => setShowExercise(false)}
          className="mb-4 text-accent hover:text-accent-dark flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          {t('breathing.back') || 'Tilbake'}
        </button>
        <div className="bg-white/60 p-6 sm:p-8 rounded-4xl shadow-lg border border-white/50">
          <BreathingExercise
            duration={5}
            onComplete={() => setShowExercise(false)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-3xl text-center">
      <div className="bg-white/60 p-8 sm:p-12 rounded-4xl shadow-lg border border-white/50">
        <h1 className="text-4xl font-bold mb-4">{t('theResetPage.title')}</h1>
        <p className="text-lg text-stone-600 mb-8">
          {t('theResetPage.subtitle')}
        </p>

        <div className="text-left space-y-6">
          <div>
            <h2 className="text-2xl font-semibold mb-3">{t('theResetPage.step1Title')}</h2>
            <p className="text-stone-600 mb-4">{t('theResetPage.step1Desc')}</p>
            <button className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 text-base font-medium text-center text-white bg-accent rounded-full hover:bg-accent-dark focus:ring-4 focus:ring-accent/50">
              {t('theResetPage.step1Button')}
            </button>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">{t('theResetPage.step2Title')}</h2>
            <p className="text-stone-600 mb-4">{t('theResetPage.step2Desc')}</p>
            <button
              onClick={() => setShowExercise(true)}
              className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 text-base font-medium text-center text-accent bg-white border border-accent rounded-full hover:bg-accent/10 focus:ring-4 focus:ring-accent/50"
            >
              {t('theResetPage.step2Button')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TheResetPage;